<template>
    <section :id="`element-${settings.id}`" class="elle-benefits padd-v" :style="{ backgroundColor: settings?.color }">
        <div class="container">
            <div class="grid12">
                <div class="l-col">
                    <UiHeadline
                        :settings="{
                            label: settings?.label,
                            headline: settings?.headline
                        }"
                    />

                    <div class="page-media w-ratio">
                        <UiImage :src="settings?.media[0].webp" :classes="'responsive full'" />
                    </div>
                </div>
                <div class="r-col">
                    <div v-if="!!settings.list.length" class="page-content-lines">
                        <div v-for="(item, index) in settings.list" :key="index" class="content-line">
                            <div class="line-title">{{ item?.label }}</div>
                            <div class="line-value">{{ item?.text }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
defineProps({
    settings: {
        type: Object,
        default: () => ({})
    }
});
</script>
